import React, { useState } from "react";

import {
	Checkbox,
	IconButton,
	ListItemText,
	Menu,
	Tooltip,
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import TagsOutlinedIcon from "@material-ui/icons/LocalOffer";

export default function TicketsTagSelect({
	tags,
	selectedTagIds = [],
	setSelectedTagIds,
}) {
	const [anchorEl, setAnchorEl] = useState(null);

	const darkMode = localStorage.getItem("darkMode") === "true" ? true : false;

	const handleOpenMenu = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleCloseMenu = () => {
		setAnchorEl(null);
	};

	return (
		<div style={{ marginTop: -22 }}>
			<FormControl fullWidth margin="dense">
				<Tooltip title="Filtro por tags">
					<IconButton
						style={{
							padding: 0,
							marginTop: "14px",
							color: `${darkMode ? "#c7c7c7" : "#6e6f70"}`,
						}}
						aria-controls="select-menu"
						aria-haspopup="true"
						onClick={handleOpenMenu}
					>
						<TagsOutlinedIcon />
					</IconButton>
				</Tooltip>
				<Menu
					id="select-menu"
					anchorEl={anchorEl}
					keepMounted
					open={Boolean(anchorEl)}
					onClose={handleCloseMenu}
					getContentAnchorEl={null}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "left",
					}}
					transformOrigin={{
						vertical: "top",
						horizontal: "left",
					}}
				>
					{tags?.length > 0 &&
						tags.map((Tag) => (
							<MenuItem dense key={Tag.id} value={Tag.id}>
								<Checkbox
									style={{
										color: Tag.color,
									}}
									size="small"
									color="primary"
									checked={selectedTagIds.indexOf(Tag.id) > -1}
									onClick={() => {
										if (selectedTagIds.indexOf(Tag.id) > -1) {
											setSelectedTagIds(
												selectedTagIds.filter((id) => id !== Tag.id)
											);
										} else {
											setSelectedTagIds([...selectedTagIds, Tag.id]);
										}
									}}
								/>
								<ListItemText primary={Tag.name} />
							</MenuItem>
						))}
				</Menu>
			</FormControl>
		</div>
	);
}
